if (typeof BetaTesters === "undefined") {
    var BetaTesters = {
      private: {
        getCaseValues: function(){
            let caseObject = {
                Devices:BetaTesters.helper.getMultiSelectValue('devices'),
                Softwares:BetaTesters.helper.getMultiSelectValue('current_software'),
                AssistiveCommunication:BetaTesters.helper.getRadioValue('assistive_communication'),
                ProductType:BetaTesters.helper.getMultiSelectValue('product_type'),
                AccessMethod:BetaTesters.helper.getMultiSelectValue('access_method'),
                TechnicalSkill:BetaTesters.helper.getRadioValue('technical_skill'),
                TestingMethodology:BetaTesters.helper.getMultiSelectValue('testing_methodology')
              };
      
              return JSON.stringify(caseObject);
        }
      },
      helper: {
        showField: function (fieldId, isRequired = false) {
          if(isRequired){
            let container = document.getElementById(fieldId)?.closest("div");
            container.querySelector('label')?.classList.add('required');
            container?.classList.remove("hidden");
  
            if(container.querySelector('input')){
              container.querySelectorAll('input').forEach(el =>{
                el.setAttribute('required','');
              });
            }else if(container.querySelector('select')){
              container.querySelector('select').setAttribute('required','');
            }
          }else{
            document
            .getElementById(fieldId)
            ?.closest("div")
            ?.classList.remove("hidden");
          }
        },
        hideField: function (fieldId) {
          let container = document.getElementById(fieldId)?.closest("div");
          container?.classList.add('hidden');
          container?.querySelector('label')?.classList.remove('required');
  
          if(container.querySelector('input')){
            container.querySelectorAll('input').forEach(el =>{
              el.removeAttribute('required');
            });
          }else if(container.querySelector('select')){
            container.querySelector('select').removeAttribute('required');
          }
  
          if (container.querySelector('[type="Radio"]')
          ) {
            if (document.querySelector(`[name="${fieldId}"]:checked`)) {
              document.querySelector(
                `[name="${fieldId}"]:checked`
              ).checked = false;
            }
          } else {
            document.getElementById(fieldId).value = "";
          }
        },
        updateSelect: function(selectId,items){
          let select = document.getElementById(selectId);
          select.innerHTML = "";
  
          let option = document.createElement("option");
            option.value = '';
            option.innerHTML = '--please select--';
            select.appendChild(option);
  
          items.forEach((item) => {
            let option = document.createElement("option");
            option.value = item;
            option.innerHTML = item;
            select.appendChild(option);
          });
        },
        getSelectValue: function(id){
            return document.getElementById(id)?.selectedOptions[0]?.value;
        },
        getRadioValue: function(name){
            return document.querySelector(`[name="${name}"]:checked`)?.value;
        },
        getMultiSelectValue: function(id){
            let values = '';
            let selectedValues = document.getElementById(id)?.selectedOptions;
            selectedValues.forEach(selection =>{
                values += selection.value + ';'
            });
            return values.slice(0, -1);
        }
      },
      countryChanged: function(select){
        let selectedOption = select.value;
        if(selectedOption === 'United States'){
          BetaTesters.helper.showField('state',true);
        }else{
          BetaTesters.helper.hideField('state');
        }
      },
      doSubmit: function (e) {
        document.getElementById("case_values").value = BetaTesters.private.getCaseValues();
      },
    };
  }
  